import StyledSvg from '@gef-ui/material-svg-shared/StyledSvg';
import * as React from 'react';
const SvgKayakFidelityLow = (props)=>{
    const id = React.useId();
    return /*#__PURE__*/ React.createElement(StyledSvg, {
        xmlns: "http://www.w3.org/2000/svg",
        width: 56,
        height: 56,
        fill: "none",
        viewBox: "0 0 56 56",
        ...props
    }, /*#__PURE__*/ React.createElement("g", {
        clipPath: `url(#kayak-fidelity-low_svg__a-${id})`
    }, /*#__PURE__*/ React.createElement("circle", {
        cx: 28.166,
        cy: 28.071,
        r: 28.002,
        fill: "#E4EFFA"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#E13632",
        d: "M.082 27.993.254 28l-.172.008c0 .817.699 1.1 2.658 1.895q.374.15.81.33c4.999 2.056 14.114 3.496 24.53 3.496s19.532-1.44 24.531-3.496q.436-.18.81-.33c1.96-.795 2.658-1.078 2.658-1.895L55.871 28l.208-.008c0-.817-.699-1.1-2.658-1.895q-.374-.15-.81-.33c-4.999-2.056-14.114-3.497-24.53-3.497S8.549 23.712 3.55 25.769q-.436.18-.81.33C.78 26.892.082 27.176.082 27.993"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#E13632",
        fillRule: "evenodd",
        d: "M.098 27.806c.336.109.741.23 1.224.372q.37.109.8.239c4.944 1.488 13.959 2.53 24.26 2.53 10.3 0 19.314-1.042 24.258-2.53l.8-.239c1.938-.575 2.63-.78 2.63-1.371l-.206-.006.205-.005c0-.255-.127-.438-.427-.61l-.89-.36c-.353-.117-.786-.246-1.311-.402q-.37-.109-.801-.239c-4.944-1.488-13.958-2.53-24.259-2.53-4.22 0-8.224.175-11.82.484-4.548.621-8.358 1.538-11.01 2.629q-.435.18-.81.33C.94 26.828.205 27.127.099 27.806",
        clipRule: "evenodd"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#720405",
        d: "M30.634 28.001c0 2.303-3.446 4.17-6.663 4.17s-5.824-1.867-5.824-4.17 2.607-4.17 5.824-4.17 6.663 1.867 6.663 4.17"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#846357",
        fillRule: "evenodd",
        d: "M25.905 46.096 36.68 12.938l.764.248L26.67 46.344z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#846357",
        d: "M27.772 41.963c-.462 2.03-1.072 3.186-.818 4.757s-.288 4.801-1.171 6.851-1.352 2.532-2.303 1.805l-.922-.834c-.479-.434-1.033-1.673-.175-3.51.858-1.839 1.594-3.652 3.218-5.335 1.299-1.347 1.989-3.05 2.171-3.734M36.154 16.48c.823-1.911 1.01-3.206 2.142-4.325s2.596-4.049 3.091-6.226.4-2.841-.797-2.815l-1.236.13c-.643.069-1.821.743-2.21 2.734-.39 1.99-.865 3.89-.544 6.206.256 1.854-.19 3.637-.446 4.296"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#50769A",
        d: "M24.207 23.853c1.212 0 3.266.453 4.651 1.54-.451.72-3.293 1.367-4.651 1.586-.142-.625-.341-2.026 0-3.126M22.377 32.008c1.874.394 4.585-.095 6.048-1.11-.394-.751-3.166-1.576-4.504-1.895-.19.612-1.798 1.883-1.544 3.005"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#E1AEA1",
        d: "M23.405 21.073c.97-.667 3.025-2.06 3.479-2.3.567-.298 1.045-.537 2.433-.552 1.389-.015 4.076.224 4.36.24.283.014 1.358-.195 1.761-.15.404.045.523.463.508.687s0 .686 0 .88c0 .195-.552.672-.717.687a.25.25 0 0 1-.239-.12c.065-.084.114-.274-.209-.358-.322-.083-.512.015-.567.075-.214-.094-.695-.284-.91-.284-.27 0-3.987.135-4.405.21s-2.09.925-2.896 1.567c-.645.514-1.065.881-1.194 1zM20.58 34.364c.777 1.442 3.18 4.12 3.638 4.6.458.482 1.168.138 1.9-.32.586-.366 2.228-1.312 2.976-1.74l.48.436-.114.206h.48c.207 0 .527-.275.596-.458s.32-.504.251-.916c-.068-.411-.755-.8-1.327-.846-.458-.037-.786.137-.893.228-.976.466-3.049 1.474-3.525 1.786-.595-.87-1.922-3.182-2.243-3.891z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#C58E80",
        d: "M23.403 21.072c.97-.666 3.025-2.06 3.479-2.299.567-.298 1.045-.537 2.433-.552 1.389-.015 4.076.224 4.36.239.283.015 1.358-.194 1.762-.15s.522.463.507.687 0 .687 0 .881-.552.672-.717.687a.25.25 0 0 1-.238-.12c.064-.084.113-.274-.21-.358-.322-.084-.512.015-.567.075-.214-.095-.696-.284-.91-.284-.27 0-3.987.134-4.405.209s-2.09.926-2.896 1.568c-.645.513-1.065.88-1.194 1z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#C48E80",
        d: "M20.576 34.365c.778 1.441 3.182 4.12 3.64 4.6.457.48 1.167.137 1.9-.32.585-.367 2.227-1.313 2.975-1.74l.48.435-.114.206h.48c.207 0 .527-.275.596-.458s.32-.503.252-.915c-.07-.412-.756-.801-1.328-.847-.458-.037-.786.137-.893.229-.976.465-3.049 1.474-3.525 1.785-.595-.87-1.922-3.182-2.243-3.891z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#7FBEC6",
        d: "M25.23 22.613c-.253-.675-.478-1.405-1.715-1.912-1.467.505-4.707 2.408-5.405 6.601-.56 3.355 1.3 6.32 2.3 7.384 1.221.063 2.336-.526 2.6-1.367 0 0-.236-.232-.38-.99-.178-.946.435-1.591 1.138-2.716.703-1.124.534-3.177.365-4.301-.168-1.125.113-1.856 1.097-2.699"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#7FBEC6",
        fillRule: "evenodd",
        d: "M21.963 34.395c-.445.21-.986.32-1.55.291-1-1.063-2.86-4.03-2.302-7.384.7-4.193 3.939-6.096 5.406-6.6.373.152.654.325.872.511.284.58-.398 1.702-.988 1.908-.62.216-.722.505-.448.634.117.056.015.175-.122.335-.183.213-.428.5-.296.805.23.534.39 4.371-.13 4.89-.292.293-.173.644-.075.935.076.225.14.414-.011.508-.077.048-.199.108-.342.18-.507.252-1.287.64-1.332 1.09-.028.278.354.654.716 1.01.357.352.696.685.602.887",
        clipRule: "evenodd"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#E7C381",
        d: "M19.39 27.263c0 .636-.451 1.007-1.274 1.152-.738.13-1.393-.35-1.393-1.152s.578-1.29 1.393-1.152c.693.192 1.274.516 1.274 1.152"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#E7C381",
        d: "M19.062 26.968c0 .476-.338.754-.954.862-.552.097-1.043-.262-1.043-.862s.434-.966 1.043-.863c.52.144.954.386.954.863"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#BB8754",
        d: "m17.702 26.583.612.226v.132zM17.639 26.98l.64.068.023.113z"
    }), /*#__PURE__*/ React.createElement("ellipse", {
        cx: 18.917,
        cy: 27.262,
        fill: "#E13632",
        rx: 0.667,
        ry: 0.992
    }), /*#__PURE__*/ React.createElement("ellipse", {
        cx: 18.798,
        cy: 27.004,
        fill: "#E13632",
        rx: 0.496,
        ry: 0.629
    }), /*#__PURE__*/ React.createElement("ellipse", {
        cx: 22.317,
        cy: 27.284,
        fill: "#E7C381",
        rx: 3.497,
        ry: 2.748
    }), /*#__PURE__*/ React.createElement("ellipse", {
        cx: 21.744,
        cy: 26.618,
        fill: "#E7C381",
        rx: 3.101,
        ry: 2.286
    })), /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("clipPath", {
        id: `kayak-fidelity-low_svg__a-${id}`
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M0 0h56v56H0z"
    }))));
};
export default SvgKayakFidelityLow;
